const footerCont  ={
    logodesc:"Revolutionizing Ticketing",
    follow:"Follow Us",
    followdesc:"Lorem ipsum dolor sit amet, \nconsectetur adipiscing elit, sed ",
    subscribe:"Subscribe Us",
    subscribetext:"Signup for our newsletter to get \nthe latest news in your inbox."

}

export default footerCont 